import CaseActions from './CaseActions.vue';

export default CaseActions;
